import {defaultUn} from './state';

/**
 * Mutación que carga los riesgos principales en el formulario.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} optprincipal contiene la información de riesgos principales.
 */
export function RiesgoPrincipal(state, optprincipal) {

    state.optprincipal = [];

    for (var i = 0; i < optprincipal.length; i++) {
        state.optprincipal.push({
            value: optprincipal[i].id.toString(),
            text: optprincipal[i].codigo + ' - ' + optprincipal[i].descripcion,
            imagen: optprincipal[i].imagen
        });
    }

    state.optprincipal.push({value: null, text: '', imagen: null});
}

/**
 * Mutación que carga los riesgos secundarios en el formulario.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} optsecundario contiene la información de riesgos secundarios.
 */
export function RiesgoRiesgoSecundario(state, optsecundario) {

    state.optsecundario = [];

    for (var i = 0; i < optsecundario.length; i++) {
        state.optsecundario.push({
            value: optsecundario[i].id.toString(),
            text: optsecundario[i].codigo + ' - ' + optsecundario[i].descripcion,
            imagen: optsecundario[i].imagen
        });
    }
    state.optsecundario.push({value: null, text: '', imagen: null});
}

/**
 * Mutación que carga los riesgos secundarios1 en el formulario.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} optsecundario1 contiene la información de riesgos secundarios1.
 */
export function RiesgoRiesgoSecundario1(state, optsecundario1) {

    state.optsecundario1 = [];

    for (var i = 0; i < optsecundario1.length; i++) {
        state.optsecundario1.push({
            value: optsecundario1[i].id.toString(),
            text: optsecundario1[i].codigo + ' - ' + optsecundario1[i].descripcion,
            imagen: optsecundario1[i].imagen
        });
    }
    state.optsecundario1.push({value: null, text: '', imagen: null});
}

/**
 * Mutación que carga la información de UN en el formulario.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} un contiene la información de UN del formulario.
 */
export function setUn(state, un) {

    state.txtprincipal = un.txtprincipal;
    state.txtsecundario = un.txtsecundario;
    state.txtsecundario1 = un.txtsecundario1;
    state.selectedUn = un;
}

/**
 * Mutación que carga la información de la tabla de guia de respuesta de emergencia formulario.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} un contiene la información de UN del formulario.
 */
export function setGre(state, gre) {
    state.guiaRespuestaEmergencia = gre;
}

/**
 * Mutación que carga la información de la tabla de guia de respuesta de emergencia formulario.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} un contiene la información de UN del formulario.
 */
export function setRotuloUN(state, link) {
    state.dirRotulo = link;
}

/**
 * Mutación que carga la información por defecto del estado selectedUn.
 *
 */
export function resetselectedUn(state) {
    Object.assign(state.selectedUn, defaultUn());
}

export function establecerCargandoSelect(state, cargando_select) {
    state.cargando_select = cargando_select;
}

/**
 * Mutación que carga la información del Número de UN.
 *
 * @param {*} state: Estado actual.
 * @param Object {greId, numberUN}: id del Gr y Número de UN.
 */
export function setNumberUN(state, {greId, numberUN}) {
    state.selectedUn.slq_gre_id = greId
    state.selectedUn.noun = numberUN
}

/**
 * Mutación que carga la información de los riesgos.
 *
 * @param {*} state: Estado actual.
 * @param {*} {principalRisk, principalRiskTemporary}: Riesgo principal y riesgo principal temporal.
 */
export function setPrincipalRisks(state, {principalRisk, principalRiskTemporary}) {
    state.selectedUn.riesgo_principal = principalRisk
    state.selectedUn.principalRiskTemporary = principalRiskTemporary
    state.selectedUn.riesgo_secundario = "0"
    state.selectedUn.riesgo_secundario1 = "0"
}

/**
 * Mutación que restablecer la información de los riesgos.
 *
 * @param {*} state: Estado actual.
 */
export function resetPrincipalRisks(state) {
    state.selectedUn.riesgo_principal = "0"
    state.selectedUn.principalRiskTemporary = "0"
    state.selectedUn.riesgo_secundario = "0"
    state.selectedUn.riesgo_secundario1 = "0"
}